import { ICall, ISms } from "../../types";
import { CallsActionsTypes } from "../actions/callsActions";

export const SET_CALLS = "calls/SET_CALLS";
export const SET_IS_CALLS_LOADING_IN_PROGRESS =
  "calls/SET_IS_CALLS_LOADING_IN_PROGRESS";
export const SET_SMS = "calls/SET_SMS";
export const SET_IS_SMS_SEND_IN_PROGRESS = "calls/SET_IS_SMS_SEND_IN_PROGRESS";

const initialState = {
  calls: [] as ICall[],
  sms: [] as ISms[],
  isCallsLoadingInProgress: false,
  isSmsSendInProgress: false,
};

type InitialStateType = typeof initialState;

export const callsReducer = (
  state = initialState,
  action: CallsActionsTypes
): InitialStateType => {
  switch (action.type) {
    case SET_CALLS:
    case SET_SMS:
    case SET_IS_CALLS_LOADING_IN_PROGRESS:
    case SET_IS_SMS_SEND_IN_PROGRESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
